import storage from './Storage';

export const TIMEZONE_ALIASES = {
  'Asia/Kolkata': ['asia/calcutta', 'calcutta', 'kolkata', 'india', 'ist', 'delhi', 'new delhi', 'mumbai', 'bombay', 'bangalore', 'bengaluru', 'chennai', 'madras', 'hyderabad', 'pune', 'ahmedabad', '+5:30', '5:30', '+5.5', '5.5', 'gmt+5:30', 'utc+5:30', 'gmt+05:30', 'utc+05:30'],
  'Asia/Calcutta': ['asia/kolkata', 'kolkata', 'calcutta', 'india', 'ist', 'delhi', 'new delhi', 'mumbai', 'bombay', 'bangalore', 'bengaluru', 'chennai', 'madras', 'hyderabad', 'pune', 'ahmedabad', '+5:30', '5:30', '+5.5', '5.5', 'gmt+5:30', 'utc+5:30', 'gmt+05:30', 'utc+05:30'],
  'Asia/Dhaka': ['bangladesh', 'dhaka', 'dacca', 'chittagong', 'sylhet', 'bdt', '+6', '+06', '6:00', '+6:00', 'gmt+6', 'utc+6', 'gmt+06:00', 'utc+06:00'],
  'Asia/Karachi': ['pakistan', 'karachi', 'lahore', 'islamabad', 'rawalpindi', 'faisalabad', 'pkt', '+5', '+05', '5:00', '+5:00', 'gmt+5', 'utc+5', 'gmt+05:00', 'utc+05:00'],
  'Asia/Kathmandu': ['nepal', 'kathmandu', 'katmandu', 'pokhara', 'npt', '+5:45', '5:45', '5.75', 'gmt+5:45', 'utc+5:45'],
  'Asia/Colombo': ['sri lanka', 'colombo', 'kandy', 'slst', '+5:30', '5:30', '+5.5', 'gmt+5:30', 'utc+5:30'],
  'Asia/Dubai': ['uae', 'united arab emirates', 'dubai', 'abu dhabi', 'sharjah', 'gulf', 'gst', '+4', '+04', 'gmt+4', 'utc+4', 'gmt+04:00'],
  'Asia/Riyadh': ['saudi arabia', 'saudi', 'riyadh', 'jeddah', 'mecca', 'medina', 'ast', '+3', '+03', 'gmt+3', 'utc+3'],
  'Asia/Qatar': ['qatar', 'doha', '+3', 'gmt+3', 'utc+3'],
  'Asia/Kuwait': ['kuwait', 'kuwait city', '+3', 'gmt+3', 'utc+3'],
  'Asia/Bahrain': ['bahrain', 'manama', '+3', 'gmt+3', 'utc+3'],
  'Asia/Muscat': ['oman', 'muscat', '+4', 'gmt+4', 'utc+4'],
  'Asia/Bangkok': ['thailand', 'bangkok', 'phuket', 'pattaya', 'ict', 'indochina', 'vietnam', 'hanoi', 'cambodia', 'phnom penh', 'laos', 'vientiane', '+7', '+07', 'gmt+7', 'utc+7'],
  'Asia/Ho_Chi_Minh': ['vietnam', 'saigon', 'hanoi', 'ho chi minh', '+7', 'gmt+7', 'utc+7'],
  'Asia/Jakarta': ['indonesia', 'jakarta', 'java', 'sumatra', 'wib', '+7', 'gmt+7', 'utc+7'],
  'Asia/Makassar': ['indonesia', 'bali', 'denpasar', 'makassar', 'wita', '+8', 'gmt+8'],
  'Asia/Jayapura': ['indonesia', 'papua', 'jayapura', 'wit', '+9', 'gmt+9'],
  'Asia/Singapore': ['singapore', 'sgt', '+8', '+08', 'gmt+8', 'utc+8'],
  'Asia/Kuala_Lumpur': ['malaysia', 'kuala lumpur', 'kl', 'penang', 'myt', '+8', 'gmt+8', 'utc+8'],
  'Asia/Manila': ['philippines', 'manila', 'cebu', 'pht', '+8', 'gmt+8', 'utc+8'],
  'Asia/Hong_Kong': ['hong kong', 'hk', 'hkt', '+8', 'gmt+8', 'utc+8'],
  'Asia/Taipei': ['taiwan', 'taipei', '+8', 'gmt+8', 'utc+8'],
  'Asia/Shanghai': ['china', 'beijing', 'shanghai', 'shenzhen', 'guangzhou', 'cst', '+8', 'gmt+8', 'utc+8'],
  'Asia/Tokyo': ['japan', 'tokyo', 'osaka', 'kyoto', 'jst', '+9', '+09', 'gmt+9', 'utc+9'],
  'Asia/Seoul': ['south korea', 'korea', 'seoul', 'busan', 'kst', '+9', 'gmt+9', 'utc+9'],
  'Asia/Yangon': ['myanmar', 'burma', 'yangon', 'rangoon', '+6:30', '6:30', 'gmt+6:30', 'utc+6:30'],
  'Asia/Kabul': ['afghanistan', 'kabul', '+4:30', '4:30', 'gmt+4:30', 'utc+4:30'],
  'Asia/Tashkent': ['uzbekistan', 'tashkent', '+5', 'gmt+5', 'utc+5'],
  'Asia/Almaty': ['kazakhstan', 'almaty', 'astana', '+5', '+6', 'gmt+5', 'utc+5'],
  'Europe/London': ['uk', 'united kingdom', 'britain', 'great britain', 'england', 'london', 'manchester', 'birmingham', 'gmt', 'bst', '+0', '+1', 'gmt+0', 'utc+0'],
  'Europe/Paris': ['france', 'paris', 'lyon', 'marseille', 'cet', 'cest', '+1', '+2', 'gmt+1', 'gmt+2'],
  'Europe/Berlin': ['germany', 'deutschland', 'berlin', 'munich', 'frankfurt', 'hamburg', 'cet', 'cest', '+1', '+2', 'gmt+1', 'gmt+2'],
  'Europe/Rome': ['italy', 'rome', 'milan', 'naples', 'cet', 'cest', '+1', '+2'],
  'Europe/Madrid': ['spain', 'madrid', 'barcelona', 'valencia', 'cet', 'cest', '+1', '+2'],
  'Europe/Amsterdam': ['netherlands', 'holland', 'amsterdam', 'rotterdam', 'cet', 'cest', '+1', '+2'],
  'Europe/Brussels': ['belgium', 'brussels', 'antwerp', 'cet', 'cest'],
  'Europe/Vienna': ['austria', 'vienna', 'cet', 'cest'],
  'Europe/Zurich': ['switzerland', 'zurich', 'geneva', 'cet', 'cest'],
  'Europe/Stockholm': ['sweden', 'stockholm', 'cet', 'cest'],
  'Europe/Oslo': ['norway', 'oslo', 'cet', 'cest'],
  'Europe/Copenhagen': ['denmark', 'copenhagen', 'cet', 'cest'],
  'Europe/Helsinki': ['finland', 'helsinki', 'eet', 'eest', '+2', '+3'],
  'Europe/Athens': ['greece', 'athens', 'eet', 'eest', '+2', '+3'],
  'Europe/Bucharest': ['romania', 'bucharest', 'eet', 'eest', '+2', '+3'],
  'Europe/Warsaw': ['poland', 'warsaw', 'krakow', 'cet', 'cest'],
  'Europe/Prague': ['czech republic', 'czechia', 'prague', 'cet', 'cest'],
  'Europe/Budapest': ['hungary', 'budapest', 'cet', 'cest'],
  'Europe/Dublin': ['ireland', 'dublin', 'ist', '+0', '+1'],
  'Europe/Lisbon': ['portugal', 'lisbon', 'porto', 'wet', 'west', '+0', '+1'],
  'Europe/Kyiv': ['ukraine', 'kyiv', 'kiev', 'eet', 'eest', '+2', '+3'],
  'Europe/Moscow': ['russia', 'moscow', 'saint petersburg', 'msk', '+3', 'gmt+3', 'utc+3'],
  'Europe/Istanbul': ['turkey', 'turkiye', 'istanbul', 'ankara', 'trt', '+3', 'gmt+3', 'utc+3'],
  'America/New_York': ['usa', 'us', 'united states', 'america', 'new york', 'nyc', 'boston', 'miami', 'atlanta', 'washington dc', 'florida', 'est', 'edt', 'eastern', '-5', '-4', 'gmt-5', 'utc-5'],
  'America/Chicago': ['usa', 'us', 'united states', 'america', 'chicago', 'houston', 'dallas', 'austin', 'texas', 'illinois', 'cst', 'cdt', 'central', '-6', '-5', 'gmt-6', 'utc-6'],
  'America/Denver': ['usa', 'us', 'united states', 'america', 'denver', 'colorado', 'utah', 'salt lake city', 'mst', 'mdt', 'mountain', '-7', '-6', 'gmt-7', 'utc-7'],
  'America/Los_Angeles': ['usa', 'us', 'united states', 'america', 'los angeles', 'la', 'san francisco', 'sf', 'california', 'seattle', 'las vegas', 'nevada', 'pst', 'pdt', 'pacific', '-8', '-7', 'gmt-8', 'utc-8'],
  'America/Phoenix': ['usa', 'us', 'arizona', 'phoenix', 'mst', '-7', 'gmt-7'],
  'America/Toronto': ['canada', 'toronto', 'ontario', 'ottawa', 'montreal', 'quebec', 'est', 'edt', '-5', '-4'],
  'America/Vancouver': ['canada', 'vancouver', 'british columbia', 'pst', 'pdt', '-8', '-7'],
  'America/Mexico_City': ['mexico', 'mexico city', 'guadalajara', 'monterrey', 'cst', '-6'],
  'America/Sao_Paulo': ['brazil', 'brasil', 'sao paulo', 'rio de janeiro', 'brt', '-3', 'gmt-3'],
  'America/Argentina/Buenos_Aires': ['argentina', 'buenos aires', 'art', '-3', 'gmt-3'],
  'America/Bogota': ['colombia', 'bogota', 'medellin', 'cot', '-5', 'gmt-5'],
  'America/Lima': ['peru', 'lima', 'pet', '-5', 'gmt-5'],
  'America/Santiago': ['chile', 'santiago', 'clt', '-3', '-4'],
  'America/Caracas': ['venezuela', 'caracas', 'vet', '-4', 'gmt-4'],
  'Australia/Sydney': ['australia', 'sydney', 'nsw', 'canberra', 'aest', 'aedt', '+10', '+11', 'gmt+10', 'gmt+11'],
  'Australia/Melbourne': ['australia', 'melbourne', 'victoria', 'vic', 'aest', 'aedt', '+10', '+11'],
  'Australia/Brisbane': ['australia', 'brisbane', 'queensland', 'qld', 'aest', '+10'],
  'Australia/Perth': ['australia', 'perth', 'western australia', 'awst', '+8'],
  'Australia/Adelaide': ['australia', 'adelaide', 'south australia', 'acst', 'acdt', '+9:30', '+10:30'],
  'Pacific/Auckland': ['new zealand', 'auckland', 'wellington', 'christchurch', 'nzst', 'nzdt', '+12', '+13'],
  'Pacific/Fiji': ['fiji', 'suva', '+12'],
  'Pacific/Honolulu': ['usa', 'hawaii', 'honolulu', 'hst', '-10', 'gmt-10'],
  'Africa/Cairo': ['egypt', 'cairo', 'alexandria', 'eet', '+2', '+3'],
  'Africa/Johannesburg': ['south africa', 'johannesburg', 'cape town', 'durban', 'sast', '+2'],
  'Africa/Lagos': ['nigeria', 'lagos', 'abuja', 'wat', '+1'],
  'Africa/Nairobi': ['kenya', 'nairobi', 'mombasa', 'eat', '+3'],
  'Africa/Casablanca': ['morocco', 'casablanca', 'rabat', '+1', '+0'],
  'Africa/Accra': ['ghana', 'accra', 'gmt', '+0'],
  'UTC': ['utc', 'gmt', 'zulu', 'coordinated universal time', 'universal time', '+0', '0:00', 'gmt+0', 'utc+0'],
};

export const POPULAR_TIMEZONES = [
  'Asia/Kolkata',
  'Asia/Calcutta',
  'UTC',
  'Asia/Dubai',
  'Asia/Dhaka',
  'Asia/Kathmandu',
  'Asia/Karachi',
  'Asia/Colombo',
  'Asia/Bangkok',
  'Asia/Singapore',
  'Asia/Kuala_Lumpur',
  'Asia/Hong_Kong',
  'Asia/Tokyo',
  'Asia/Riyadh',
  'Asia/Qatar',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Moscow',
  'Europe/Istanbul',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Toronto',
  'America/Sao_Paulo',
  'America/Argentina/Buenos_Aires',
  'Australia/Sydney',
  'Australia/Melbourne',
  'Pacific/Auckland',
  'Africa/Cairo',
  'Africa/Johannesburg',
  'Africa/Lagos',
  'Africa/Nairobi',
];

export const getAllSupportedTimezones = () => {
  const set = new Set();
  // Add common & popular ones first
  POPULAR_TIMEZONES.forEach(tz => set.add(tz));

  try {
    if (typeof Intl !== 'undefined' && typeof Intl.supportedValuesOf === 'function') {
      const all = Intl.supportedValuesOf('timeZone');
      if (Array.isArray(all)) {
        all.forEach(tz => set.add(tz));
      }
    }
  } catch (e) {}

  // Ensure key aliases are explicitly included
  if (!set.has('Asia/Calcutta')) set.add('Asia/Calcutta');
  if (!set.has('Asia/Kolkata')) set.add('Asia/Kolkata');
  if (!set.has('UTC')) set.add('UTC');

  return Array.from(set);
};

export const getTimezoneOffsetString = (timeZone) => {
  try {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'shortOffset',
    });
    const parts = formatter.formatToParts(now);
    const tzPart = parts.find((p) => p.type === 'timeZoneName');
    if (tzPart && tzPart.value) return tzPart.value;
  } catch (e) {}

  try {
    const now = new Date();
    const str = now.toLocaleString('en-US', { timeZone, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    const match = str.match(/(\d{2})\/(\d{2})\/(\d{4}),?\s+(\d{2}):(\d{2}):(\d{2})/);
    if (match) {
      const [, m, d, y, h, min, s] = match;
      const targetUtc = Date.UTC(+y, +m - 1, +d, +h, +min, +s);
      const diffMinutes = Math.round((targetUtc - now.getTime()) / 60000);
      const sign = diffMinutes >= 0 ? '+' : '-';
      const absMinutes = Math.abs(diffMinutes);
      const hours = Math.floor(absMinutes / 60);
      const mins = absMinutes % 60;
      return `GMT${sign}${hours}${mins ? `:${mins < 10 ? '0' : ''}${mins}` : ''}`;
    }
  } catch (e) {}
  return '';
};

export const getTimezoneListWithOffsets = () => {
  const allTzs = getAllSupportedTimezones();
  return allTzs.map((tz) => {
    const offset = getTimezoneOffsetString(tz);
    const friendlyName = tz.replace(/_/g, ' ');
    const aliases = (TIMEZONE_ALIASES[tz] || []).join(' ');
    
    // Generate extra offset variations for search matching (e.g. "+5:30", "5:30", "utc+5:30")
    let extraOffsetTags = '';
    if (offset) {
      const cleanOffset = offset.replace('GMT', '').replace('UTC', '').trim();
      extraOffsetTags = `${offset} ${cleanOffset} UTC${cleanOffset} GMT${cleanOffset}`;
    }

    const searchKey = `${friendlyName} ${tz} ${offset} ${aliases} ${extraOffsetTags}`.toLowerCase();

    return {
      value: tz,
      label: offset ? `${friendlyName} (${offset})` : friendlyName,
      offset,
      searchKey,
    };
  });
};

export const getUserTimezone = () => {
  const stored = storage.getKey('timezone');
  if (stored) return stored;
  return window?.siteConfig?.default_user_timezone || 'Asia/Kolkata';
};

/**
 * Robust UTC date parser to ensure dates with or without Z / offsets are correctly treated as UTC timestamps.
 */
export const parseUtcDate = (date) => {
  if (!date) return null;
  if (date instanceof Date) return isNaN(date.getTime()) ? null : date;
  if (typeof date === 'number') {
    const d = new Date(date);
    return isNaN(d.getTime()) ? null : d;
  }
  if (typeof date === 'string') {
    let s = date.trim();
    if (!s) return null;
    if (/^\d{10,13}$/.test(s)) {
      const num = parseInt(s, 10);
      const d = new Date(s.length === 10 ? num * 1000 : num);
      return isNaN(d.getTime()) ? null : d;
    }
    // If format is YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss without timezone indicator
    if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2}(\.\d{1,6})?)?$/.test(s)) {
      s = s.replace(' ', 'T') + 'Z';
    }
    const d = new Date(s);
    if (!isNaN(d.getTime())) return d;
    const raw = new Date(date);
    return isNaN(raw.getTime()) ? null : raw;
  }
  return null;
};

export const formatUserDateTime = (date, options = {}) => {
  if (!date) return '-';
  try {
    const d = parseUtcDate(date);
    if (!d) return '-';
    return d.toLocaleString('en-GB', {
      timeZone: getUserTimezone(),
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true,
      ...options,
    });
  } catch (e) {
    return String(date);
  }
};

export const formatUserDate = (date, options = {}) => {
  if (!date) return '-';
  try {
    const d = parseUtcDate(date);
    if (!d) return '-';
    return d.toLocaleDateString('en-GB', {
      timeZone: getUserTimezone(),
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      ...options,
    });
  } catch (e) {
    return String(date);
  }
};

export const formatUserTime = (date, options = {}) => {
  if (!date) return '-';
  try {
    const d = parseUtcDate(date);
    if (!d) return '-';
    return d.toLocaleTimeString('en-US', {
      timeZone: getUserTimezone(),
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      ...options,
    });
  } catch (e) {
    return String(date);
  }
};

export const getTodayInUserTimezone = (tz = getUserTimezone()) => {
  try {
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    return formatter.format(new Date());
  } catch {
    return new Date().toISOString().split('T')[0];
  }
};

export const getRelativeDateInUserTimezone = (daysOffset, tz = getUserTimezone()) => {
  try {
    const now = new Date();
    const target = new Date(now.getTime() + daysOffset * 86400000);
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    });
    return formatter.format(target);
  } catch {
    const d = new Date();
    d.setDate(d.getDate() + daysOffset);
    return d.toISOString().split('T')[0];
  }
};


